// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"835b8781","455":"6504147e","829":"a9716c93"}[chunkId] + ".chunk.js";
};